(function () {
  'use strict';
  angular
    .module('com.module.customstyles')
    .run(function ($rootScope, gettextCatalog) {
        
    });

})();
